/**
 * 全局错误边界 — 防止任何 React 错误导致黑屏
 * 显示错误堆栈,方便调试
 */
import { Component } from 'react';
import { AlertTriangle, RefreshCw, Home } from 'lucide-react';

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[ErrorBoundary] 捕获错误:', error, errorInfo);
    this.setState({ errorInfo });
  }

  handleReload = () => {
    window.location.reload();
  };

  handleHome = () => {
    window.location.href = '/';
  };

  handleReset = () => {
    // 清掉可能出错的 localStorage
    try {
      const ok = window.confirm('确定重置?这会清掉登录状态。');
      if (ok) {
        localStorage.removeItem('fucai3d_max_user');
        localStorage.removeItem('fucai3d_token');
        localStorage.removeItem('fucai3d_all_users');
        window.location.reload();
      }
    } catch {}
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="min-h-screen flex items-center justify-center p-4" style={{ background: 'var(--bg-base)' }}>
        <div className="max-w-md w-full card !p-6 space-y-4">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-full bg-red-500/20 flex items-center justify-center flex-shrink-0">
              <AlertTriangle size={24} className="text-red-400" />
            </div>
            <div>
              <h1 className="text-lg font-bold text-red-300">页面出错了</h1>
              <p className="text-xs text-ink-3 mt-0.5">已捕获错误,可以重试或重置</p>
            </div>
          </div>

          <div className="bg-bg-elev border border-red-500/30 rounded-lg p-3">
            <div className="text-xs text-red-300 font-mono break-all">
              {this.state.error?.message || String(this.state.error)}
            </div>
            {this.state.errorInfo?.componentStack && (
              <details className="mt-2">
                <summary className="text-[10px] text-ink-3 cursor-pointer">查看堆栈</summary>
                <pre className="text-[10px] text-ink-3 mt-1 overflow-auto max-h-40 whitespace-pre-wrap">
                  {this.state.errorInfo.componentStack}
                </pre>
              </details>
            )}
          </div>

          <div className="grid grid-cols-3 gap-2">
            <button onClick={this.handleReload} className="btn-primary !text-xs !py-2 flex items-center justify-center gap-1">
              <RefreshCw size={12} /> 刷新
            </button>
            <button onClick={this.handleHome} className="btn-secondary !text-xs !py-2 flex items-center justify-center gap-1">
              <Home size={12} /> 主页
            </button>
            <button onClick={this.handleReset} className="btn-secondary !text-xs !py-2 text-red-400 border-red-500/30">
              重置
            </button>
          </div>

          <div className="text-[10px] text-ink-3 text-center pt-2">
            如果持续出错,请截图此页面发给开发者
          </div>
        </div>
      </div>
    );
  }
}
